/*
 * File: packages/utils/device/mappedDeviceInfoFromJson.ts
 * 연결·등록 시 받은 raw JSON → 화면/저장용 MappedDeviceInfo (함수명: mapRawDeviceJsonToMappedInfo).
 */
import { DeviceType } from '../../types/device/common/deviceTypes';
import type { MappedDeviceInfo } from '../../types/device/dto';

/**
 * ConnectDevice / packet JSON을 등록·표시용 MappedDeviceInfo로 정규화 (LITE/MINI 공통).
 * 프론트·백엔드 공통 단일 구현.
 */

/**NOTE
 *{
    "serial_number": "G2520BLT025",
    "manufacture_date": "2023-01-01",
    "hw_version": "v1.0",
    "fw_version": "v1.0.0",
    "sensor_type": [
        {
            "value": 0,
            "label": "O2LF"
        },
        {
            "value": 5,
            "label": "EX"
        },
        {
            "value": 1,
            "label": "CO"
        },
        {
            "value": 2,
            "label": "H2S"
        },
        {
            "value": 255,
            "label": ""
        }
    ],
    "calibration_due_date": [
        166,
        166,
        166,
        166,
        365
    ],
    "bump_due_date": [
        166,
        166,
        166,
        166,
        365
    ],
    "last_span_calibration_days": [
        "2026-03-30",
        "2026-03-30",
        "2026-03-30",
        "2026-03-30",
        "2023-01-01"
    ],
    "last_bump_days": [
        "2026-03-30",
        "2026-03-30",
        "2026-03-30",
        "2026-03-30",
        "2023-01-01"
    ],
    "activation_date_time": "2025-08-18",
    "unit": [
        {
            "value": 1,
            "label": "%VOL"
        },
        {
            "value": 2,
            "label": "%LEL"
        },
        {
            "value": 0,
            "label": "PPM"
        },
        {
            "value": 0,
            "label": "PPM"
        },
        {
            "value": 0,
            "label": "PPM"
        }
    ],
    "decimal_point": [
        1,
        0,
        0,
        1,
        0
    ],
    "last_zero_calibration_days": [
        "2026-03-30",
        "2026-03-30",
        "2026-03-30",
        "2026-03-30",
        "2023-01-01"
    ],
    "min_calibration_due_date": 166,
    "min_bump_test_due_date": 166
} 
 * 
 * 
 * 



 */
export function mapRawDeviceJsonToMappedInfo(json: unknown): MappedDeviceInfo {
  const o = (json && typeof json === 'object' ? json : {}) as Record<string, unknown>;
  const serial = (o.serial_number as string) || '';
  const isMini = serial.includes('BMI');

  const equipped = o.equipped_sensor;
  const sensorTypeArr = o.sensor_type as Array<{ label?: string }> | undefined;

  const sensorTypes = isMini
    ? [equipped].filter(Boolean).map(String)
    : (sensorTypeArr || [])
        .map(s => s.label)
        .filter((label): label is string => !!label && label.trim().length > 0);

  const hw = o.hw_version;
  const hwVersion = Array.isArray(hw) ? hw.join('.') : String(hw ?? '');

  return {
    serial_number: serial,
    device_type: isMini ? DeviceType.MINI : DeviceType.LITE,
    manufacturer_date: String(o.manufacture_date ?? ''),
    hw_version: hwVersion,
    fw_version: String(o.fw_version ?? ''),
    sensor_types: sensorTypes,
    calibration_due_date: isMini
      ? String(o.calibration_due_date ?? '')
      : String(o.min_calibration_due_date ?? ''),
    bump_test_due_date: isMini
      ? String(o.bump_due_date ?? '')
      : String(o.min_bump_test_due_date ?? ''),
    status: 'ACTIVE',
    cloud_name: String(o.cloud_name ?? ''),
    cloud_user: String(o.cloud_user ?? ''),
    cloud_desc: String(o.cloud_desc ?? ''),
  };
}
